import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { Alert } from '@mui/material';
import {
  WAuthLayout,
  WTranslationProvider,
  WPasswordRecoveryForm,
} from '@wareclouds/wareclouds-ui';

import logo from '../../../assets/img/logo.svg';
import { useYupValidationTranslations } from '../../common/hooks';
import { useRequestPassword } from '../services';
import {
  passwordRequestSchema,
  defaultValuesPasswordRequestForm,
} from '../utils';

const FIRST_LOGIN = 'first-login';

export default function PasswordRecoveryPage() {
  const { t } = useTranslation(['auth']);

  const navigate = useNavigate();
  const location = useLocation();
  const mode = location.state?.mode || 'forgot';

  const isInitialLogin = mode === FIRST_LOGIN;
  const title = isInitialLogin
    ? t('password_request.first_login.title', { ns: 'auth' })
    : t('password_request.forgot.title', { ns: 'auth' });
  const subtitle = isInitialLogin
    ? t('password_request.first_login.subtitle', { ns: 'auth' })
    : t('password_request.forgot.subtitle', { ns: 'auth' });

  const translateError = useYupValidationTranslations();

  const {
    mutate: postRecoveryPassword,
    isPending,
    isError,
  } = useRequestPassword();

  const onSubmit = (data) => {
    postRecoveryPassword({
      user_name: data.username,
    });
  };

  return (
    <WTranslationProvider t={t} translateError={translateError}>
      <WAuthLayout title={title} subtitle={subtitle} logo={logo}>
        <WPasswordRecoveryForm
          onSubmit={onSubmit}
          onReturnClick={() => {
            navigate('/login');
          }}
          isSubmitting={isPending}
          resolver={yupResolver(passwordRequestSchema)}
          defaultValues={defaultValuesPasswordRequestForm}
        />
        {isError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {t('password_request.error', { ns: 'auth' })}
          </Alert>
        )}
      </WAuthLayout>
    </WTranslationProvider>
  );
}
